<script>
  import { link, useLocation } from '../svelte-navigator';
  import { Grid, Loading, Notification, BarGraphCell, StatusCountCell } from '../components';
  import Fa from 'svelte-fa';
  import { faHome } from '@fortawesome/free-solid-svg-icons';
  import { readonly, queries, history } from '../stores.js';
  import { getQuery, getHistory, getLifecycleStatusCount, getComplianceStatusCount } from '../data.js';
  import { getDateTimeString, getWhen, weekFormatter, numberWithDigitGrouping } from '../utils.js';

  const location = useLocation();
  const searchReg = /\?n=(\d+)/;

  const columns = [
    // RowKey is unix time seconds, Date expects unix time milliseconds
    { name: "Timestamp", value: x => Number(x.RowKey), formatter: x => getDateTimeString(new Date(x * 1000)), extra: x => getWhen(new Date(Number(x.RowKey) * 1000)) },
    { name: "Stock", value: x => x.TotalAvailable, formatter: x => numberWithDigitGrouping(x), component: BarGraphCell, props: x => ({ numericValue: x.TotalAvailable, max: getMax("TotalAvailable") }) },
    { name: "Price", value: x => x.MedianUnitPrice.toPrecision(4)/1, formatter: x => "$" + x, component: BarGraphCell, props: x => ({ numericValue: x.MedianUnitPrice, max: getMax("MedianUnitPrice") }) },
    { name: "Min Lead Time", value: x => x.MinLeadTimeDays, formatter: x => weekFormatter(x), component: BarGraphCell, props: x => ({ numericValue: x.MinLeadTimeDays, max: getMax("MinLeadTimeDays") }) },
    { name: "Avg Lead Time", value: x => x.AvgLeadTimeDays, formatter: x => weekFormatter(x), component: BarGraphCell, props: x => ({ numericValue: x.AvgLeadTimeDays, max: getMax("AvgLeadTimeDays") }) },
    { name: "Max Lead Time", value: x => x.MaxLeadTimeDays, formatter: x => weekFormatter(x), component: BarGraphCell, props: x => ({ numericValue: x.MaxLeadTimeDays, max: getMax("MaxLeadTimeDays") }) },
    { name: "Lifecycle Status", value: x => getLifecycleStatusCount(JSON.parse(x.LifecycleStatus)), component: StatusCountCell },
    { name: "RoHS", value: x => getComplianceStatusCount(x.RoHS ? JSON.parse(x.RoHS) : ""), component: StatusCountCell }
  ];

  export let id = null;
  
  let n = $location.search.match(searchReg) ? $location.search.match(searchReg)[1] : -1;

  let componentHistory;

  async function loadHistory() {
    let componentQuery;
    if ($queries.length > 0) {
      componentQuery = $queries.find(x => x.PartitionKey === id);
    } else {
      componentQuery = await getQuery(id);
    }
    
    if ($history.length > 0) {
      componentHistory = $history.find(x => x.ID === id)?.History;
    } else {
      let h = await getHistory(id, n);
      componentHistory = h.History;
    }

    document.title = `History ${componentQuery?.Name || ""}`;

    return { componentQuery, componentHistory };
  }

  function getMax(col) {
    return Math.max(...componentHistory.map(x => x[col]));
  }
</script>

{#await loadHistory()}
  <Loading visible />
{:then data}
  <div class="container">
    <div class="toolbar">
      <a href="/" use:link><Fa icon={faHome} color="#666" /></a>
      {#if !$readonly}<a href={"/query/" + id} use:link>Run Query</a>{/if}
      <div class="component">
        {data.componentQuery?.Name || ""}
        {data.componentQuery?.Tags ? `(${data.componentQuery?.Tags})` : ""}
      </div> 
    </div>
    {#if data.componentHistory?.length > 0}
      <Grid data={data.componentHistory} {columns} sortCol="Timestamp" sortAsc={false} banded sortable />
    {:else}
      <span>No history yet 🤷‍♂️</span>
    {/if}
  </div>
{:catch error}
  <Notification icon="error" message={error.message} visible />
{/await}

<style>
  .container {
    display: grid;
    grid-template-rows: 32px auto;
    width: 100%;
    height: 100vh;
  }

  .toolbar {
    grid-row-start: 1;
    display: grid;
    grid-template-columns: max-content max-content auto min-content;
    align-items: center;
    gap: 10px;
    padding: 0px 0px 5px 5px;
  }

  .component {
    color: dimgray;
  }

  span {
    grid-row: 2;
    align-self: center;
    justify-self: center;
    font-size: 2em;
  }
</style>

